import mixpanel, { Callback } from "mixpanel-browser";
import { useCallback } from "react";
import { Organization } from "types/app";
import { useQuery } from "react-query";

export const useMixpanel = () => {
  const { data: orgData } = useQuery<Organization>(["OrgDetails"]);

  const track = useCallback(
    (
      event: string,
      props?: Record<string, string | number | boolean | string[] | Date>,
      callback?: Callback,
    ) => {
      const mergedProps: Record<string, string | number | boolean | string[] | Date> = {
        ...(orgData?.status ? { "Organization Status": orgData.status } : {}),
        ...props,
      };
      const safeProps = Object.fromEntries(
        Object.entries(mergedProps).map(([key, value]) => {
          if (Array.isArray(value)) return [key, value.join(", ")];
          if (value instanceof Date) return [key, value.toISOString()];
          return [key, value];
        }),
      ) as Record<string, string | number | boolean>;
      if (mixpanel) {
        mixpanel.track(event, safeProps, callback);
      }
    },
    [orgData?.status],
  );

  return { track };
};

export const useIntegrationMixpanelEvent = () => {
  const { track } = useMixpanel();

  const { data: orgDetails } = useQuery<Organization>(["OrgDetails"]);

  const triggerMixpanelEvent = useCallback(
    (eventName: string, callback?: Callback) => {
      if (orgDetails) {
        track(
          eventName,
          {
            "Subscription Plan": orgDetails?.subscription_plan,
            "User Role": orgDetails?.user_role,
            Industry: orgDetails?.organization_industry,
            Size: orgDetails?.organization_size,
          },
          callback,
        );
      }
    },
    [orgDetails, track],
  );

  return { triggerMixpanelEvent };
};
